// 数值保留指定位数小数的过滤器
export function fixDecimal(value, decimal = 2) {
  // 容错处理：空值、非数字返回空字符串，避免显示 NaN
  if (value === undefined || value === null || isNaN(Number(value))) {
    return "";
  }

  // 确保小数位数参数是合法的非负整数，非法则重置为默认值2
  const validDecimal = Number.isInteger(decimal) && decimal >= 0 ? decimal : 2;

  // 直接保留指定小数位（不乘以100，也不加百分号）
  return Number(value).toFixed(validDecimal);
}
